<div *ngIf="chartOption" class="chart-container">
  <div class="row-container">
    <div class="title">{{title}}</div>
    <div class="flex"></div>
  </div>
  <div echarts [options]="chartOption" class="chart"></div>
</div>
